<template>
  <div class="parent">
    <div class="box">
      <template v-if="routerName === '商品列表'">
        <div class="topbar" v-show="false">
          <span>购物车（10）</span>
          <span>买过（20）</span>
          <span>预约（20）</span>
          <span>收藏（20）</span>
        </div>
        <div class="search-bar" v-if="searchData && searchData.type === 2">
          <div class="bar">
            <template v-if="vinDetails.titleStr">
              <img :src="vinDetails.logo" alt="" class="vehicle-logo" />
              <div class="title">
                <span class="vehicle-title">车型：{{ vinDetails.titleStr }}</span>
              </div>
              <span class="info" @click="openVinDetailsPopup(false)">详情>></span>
            </template>
          </div>
          <div class="search-box">
            <Search
              ref="vinKeywordSearch"
              :need-two-word="true"
              history-type="vinKeyword"
              @searchKeywordChange="searchKeywordChange"
            ></Search>
          </div>
        </div>
      </template>

      <!-- 主从目录：列表页按 listSettings 渲染；配件详情嵌套时不展示目录，只保留筛选/排序 -->
      <CatalogSidebar
        ref="catalogSidebar"
        class="flex1 overflow-hidden"
        :settings="catalogWorkSettings"
        :main-settings="catalogMainSettings"
        :has-main-catalog="subResolveHasMainCatalog"
        @change="onCatalogChange"
      >
        <!-- 排序和筛选：项来自 search 返回的 listSettings.sortSettings / filterSettings -->
        <div class="filter-section relative flex" v-if="enableSort || enableFilter || allowViewSwitch">
          <div class="sort-box flex flex1">
            <template v-if="enableSort && sortViewList.length">
              <template v-for="(item, sIndex) in sortViewList">
                <el-divider direction="vertical" v-if="sIndex > 0" :key="'sort-d-' + sIndex"></el-divider>
                <div
                  class="sort-item"
                  :key="'sort-i-' + sIndex"
                  @click="sortItemClick(item)"
                  :class="{ active: isSortItemActive(item) }"
                >
                  <span>{{ item.name }}</span>
                  <SortIcon
                    v-if="item.mode === 'switch'"
                    :code-name="item.fields"
                    :orders="item.orders"
                    ref="sortIcons"
                    :current-code="currentCode"
                    @changeSort="e => changeSort(e, item.fields)"
                  ></SortIcon>
                </div>
              </template>
            </template>
            <el-divider
              direction="vertical"
              v-if="enableSort && sortViewList.length && enableFilter && filterViewList.length"
            ></el-divider>
            <template v-if="enableFilter">
              <!-- 下拉筛选项：可选值一律来自 filterSettings.values -->
              <template v-for="(filterItem, fIndex) in selectFilterViewList">
                <div
                  :key="'filter-' + filterItem.key + '-' + fIndex"
                  :class="{
                    relative: true,
                    'sort-item': true,
                    'cursor-pointer': true,
                    'filter-active': activeFilterKey === filterItem.key,
                    active: !!getFilterSelectedValue(filterItem)
                  }"
                  @click="openSelectFilterPopup(filterItem, fIndex)"
                >
                  <span v-if="!getFilterSelectedValue(filterItem)">{{ filterItem.label }}</span>
                  <div class="chooseTxt" v-else>
                    <span>{{ getFilterSelectedLabel(filterItem) }}</span>
                  </div>
                  <div class="trigger-icon">
                    <i class="el-icon-arrow-down"></i>
                  </div>
                </div>
                <el-divider direction="vertical" :key="'filter-d-' + filterItem.key + '-' + fIndex"></el-divider>
              </template>
              <template v-if="filterMap.isPromotion">
                <div class="sort-item checkbox-item" :class="{ active: params.isPromotion }">
                  <el-checkbox :true-label="1" :false-label="0" v-model="params.isPromotion" @change="getProducts">{{
                    filterMap.isPromotion.label
                  }}</el-checkbox>
                </div>
                <el-divider direction="vertical"></el-divider>
              </template>
              <template v-if="filterMap.hasStock">
                <div class="sort-item checkbox-item" :class="{ active: params.hasStock }">
                  <el-checkbox v-model="params.hasStock" @change="remenberParams">{{
                    filterMap.hasStock.label
                  }}</el-checkbox>
                </div>
                <el-divider direction="vertical"></el-divider>
              </template>
              <template v-if="filterMap.isNormalBuy">
                <div class="sort-item checkbox-item" :class="{ active: params.isNormalBuy }">
                  <el-checkbox v-model="params.isNormalBuy" @change="remenberParams">{{
                    filterMap.isNormalBuy.label
                  }}</el-checkbox>
                </div>
              </template>
            </template>
          </div>
          <div class="view-toggle flex">
            <div class="top-pagination">
              <span>共{{ total }}条</span>
              <el-button type="text" :disabled="params.page <= 1" @click="lastPage">{{ "<" }}</el-button>
              <span>{{ params.page }}/{{ Math.ceil(total / params.pageSize) }}</span>
              <el-button type="text" :disabled="params.page >= Math.ceil(total / params.pageSize)" @click="nextPage">{{
                ">"
              }}</el-button>
            </div>
            <template v-if="allowViewSwitch">
              <el-tooltip content="列表视图" placement="top">
                <i :class="{ 'el-icon-s-unfold': true, active: pageIndex === 1 }" @click="changeShowType(1)"></i>
              </el-tooltip>
              <el-tooltip content="网格视图" placement="top">
                <i :class="{ 'el-icon-menu': true, active: pageIndex === 2 }" @click="changeShowType(2)"></i>
              </el-tooltip>
            </template>
          </div>
          <!-- 复用旧版整栏弹窗样式；选项和确认逻辑仍由当前 filterSettings 驱动 -->
          <BrandPanel
            ref="selectFilterPanel"
            :label="activeFilterItem ? activeFilterItem.label : ''"
            :search-placeholder="activeFilterItem ? '搜索' + activeFilterItem.label + '...' : '搜索...'"
            @close="closeSelectFilterPopup"
            @change="selectActiveFilterConfirm"
          ></BrandPanel>
          <!-- 多级筛选弹窗（自定义目录/分类）：与 master 分支 CategorieSelect 一致的分栏逐级展开 -->
          <CategorieSelect
            ref="selectTreeFilterPanel"
            :title="activeFilterItem ? activeFilterItem.label : '分类选择'"
            :search-placeholder="activeFilterItem ? '搜索' + activeFilterItem.label + '...' : '搜索...'"
            @close="closeSelectFilterPopup"
            @change="selectActiveFilterConfirm"
          ></CategorieSelect>
        </div>

        <!-- 产品列表 -->
        <div class="product-content" v-newloading="loading">
          <template v-if="pageIndex === 1">
            <product-list :list="productListData" @refresh="getProducts(true)"></product-list>
          </template>
          <template v-if="pageIndex === 2">
            <div class="card-product">
              <template v-for="item in productListData">
                <Product @refreshProductList="getProducts(true)" :info="item" :key="item.uuid"></Product>
              </template>
            </div>
          </template>
          <!-- 空状态 -->
          <div v-if="productListData.length === 0" class="empty-state">
            <i class="el-icon-box"></i>
            <p>暂无商品数据</p>
            <el-button type="primary" @click="resetParamsAndSearch">重置筛选条件</el-button>
          </div>
          <div class="card-product"></div>
        </div>

        <!-- 分页 -->
        <div class="pagination-container" v-if="productListData.length > 0">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="params.page"
            :page-sizes="pageSizeList"
            :page-size="params.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </CatalogSidebar>
    </div>

    <!-- 弹窗 -->
    <el-dialog
      title="车辆配置详情"
      :visible.sync="vinDetailsIframeVisible"
      top="2vh"
      width="1200px"
      custom-class="custom-dialog"
    >
      <iframe
        v-if="vinDetailsIframeVisible"
        class="vinDetailsIframe"
        :src="vinDetailsIframeUrl"
        frameborder="0"
      ></iframe>
    </el-dialog>
    <el-dialog
      title="选择具体的车型"
      :visible.sync="chooseVinVisibel"
      top="2vh"
      width="800px"
      custom-class="custom-dialog"
    >
      <div class="vinList">
        <div
          v-for="item in vinList"
          :key="item.id"
          @click="chooseVin(item)"
          :class="{ item: true, active: item.id === vinDetails.id }"
        >
          <img :src="item.logo" alt="" class="vehicle-logo" />
          <div class="title">
            <span>{{ item.titleStr }}</span>
          </div>
          <span class="info" @click.stop="openVinDetailsPopup(item)">详情>></span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Search from "../../components/common/Search.vue";
import ProductList from "../../components/productList/Index.vue";
import shoppingCartIcon from "@/assets/img/newProducts/shopping-cart.svg";
import SortIcon from "../../components/common/Sort.vue";
import { getGoodsList, getDataByVin } from "@/api/goods/index.js";
import Product from "../../components/products/components/Product.vue";
import CatalogSidebar from "../../components/common/CatalogSidebar.vue";
import BrandPanel from "../../components/common/BrandPanel.vue";
import CategorieSelect from "../../components/common/CategorieSelectNew.vue";
import {
  applyListSettingsFromSearch,
  buildPartsFilterViewList,
  buildPartsSortViewList,
  buildCatalogQueryFromSelection,
  buildDefaultCatalogQueryFromSettings,
  buildFirstMainCatalogQueryFromSettings,
  cloneMallListSettings,
  hasVinMainCatalog,
  mergeVinListSettingsFromSearch
} from "@/utils/mallListSettingsView";
import { debounce } from "lodash";

export default {
  name: "MallGoodsList",
  components: {
    Search,
    ProductList,
    SortIcon,
    Product,
    CatalogSidebar,
    BrandPanel,
    CategorieSelect
  },
  props: {
    // 详情「互换商品」嵌套：不能靠 $route.name，否则缓存中的列表页进详情会被误判成嵌套、目录被清空
    embedded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      chooseVinVisibel: false,
      vinDetailsIframeVisible: false,
      pageIndex: 1,
      vinDetailsIframeUrl: "",
      productListData: [],
      pageSizeList: [10, 20, 30, 40],
      params: {
        noCategory: false,
        isNormalBuy: false,
        hasStock: true,
        isPromotion: 0,
        keyword: "",
        page: 1,
        pageSize: 10,
        sort: "",
        productionPlace: "",
        brand: "",
        category: "",
        vin: "",
        vmid: "",
        // 主从目录：写入 POST /mall/goods/search 的 mainCatalog / subCatalog
        mainCatalog: undefined,
        subCatalog: undefined,
        // 动态筛选项（自定义目录/品类等）
        custom: "",
        class: "",
        // 品类选中两级时，第二级传 classBrand
        classBrand: "",
        // 自定义目录ID / 分类ID（多级筛选，按后端节点 id 提交）
        customId: 0,
        categoryId: 0,
        // 历史查件：有 historyId 时只传 historyId/historyType，不传 keyword
        historyId: 0,
        historyType: "",
        areaId: 0,
        // 商品区 setting=4 推荐商品：关联 mall/index modules[].id
        moduleId: 0
      },
      total: 0,
      shoppingCartIcon,
      vinList: [],
      vinDetails: {},
      currentCode: "",
      componentParams: {},
      // listSettings：来自商品 search 响应（工作副本，切目录会合并 catalogDetails）
      mallListSettings: null,
      // 关键字/首开整份快照：主目录固定用这份
      keywordListSettings: null,
      // 当前工作副本是否来自带 mainCatalog 的 search（决定从目录解析方式）
      subResolveHasMainCatalog: false,
      // 主从目录：首包 listSettings 落定前禁止目录联动二次 search；关键字刷新配置时跳过一次 change
      pageInited: false,
      skipNextCatalogChange: false,
      // 入口/关键字首包去重，避免 keep-alive 或默认选中打出相同 page=1 请求
      lastFirstPageQueryKey: "",
      // 当前展开的下拉筛选项 key
      activeFilterKey: "",
      activeFilterItem: null,
      // VIN：search-vin 返回的 listSettings；catalogs 有值时冻结主目录、点选第一个查询
      vinListSettings: null,
      isVinMainCatalog: false,
      // 作废进行中的 search-vin，避免关键字进列表后旧 VIN 回调又写成 v=5
      vinQueryToken: 0,
      // 作废过期的 goods/search 回包，避免 keep-alive 下旧请求写回上一份 listSettings
      searchQueryToken: 0,
      // 首页商品目录进入：后续 search 传 v=3，主目录 tabs 冻结
      isHomePageGoodsCategory: false
    };
  },
  computed: {
    searchData() {
      return this.$store.getters["search/getSearchData"];
    },
    /** mall/companies.hasMainCatalog：已设主目录时有货/常购不落本地、关键字搜索清空 */
    companyHasMainCatalog() {
      const company = this.$store.getters["companyInfo/companyInfo"] || {};
      return !!company.hasMainCatalog;
    },
    routerName() {
      return this.$route.name;
    },
    // 配件详情「互换商品」嵌套本页：不展示主从目录
    isEmbeddedInDetail() {
      return this.embedded;
    },
    /** 详情嵌套时强制 catalogLayout=none，CatalogSidebar 只透传筛选/列表 */
    catalogWorkSettings() {
      if (!this.isEmbeddedInDetail) return this.mallListSettings;
      if (!this.mallListSettings) return { catalogLayout: "none", catalogs: null };
      return {
        ...this.mallListSettings,
        catalogLayout: "none",
        catalogs: null,
        catalogDetails: null
      };
    },
    catalogMainSettings() {
      if (this.isEmbeddedInDetail) return this.catalogWorkSettings;
      return this.keywordListSettings;
    },
    sortViewList() {
      return buildPartsSortViewList(this.mallListSettings);
    },
    filterViewList() {
      return buildPartsFilterViewList(this.mallListSettings);
    },
    filterMap() {
      const map = {};
      this.filterViewList.forEach(item => {
        map[item.key] = item;
      });
      return map;
    },
    // 下拉类筛选项（非系统开关），可选值来自 filterSettings.values
    selectFilterViewList() {
      return this.filterViewList.filter(
        item => item.key !== "hasStock" && item.key !== "isPromotion" && item.key !== "isNormalBuy"
      );
    },
    enableSort() {
      return !this.mallListSettings || this.mallListSettings.enableSort !== false;
    },
    enableFilter() {
      return !this.mallListSettings || this.mallListSettings.enableFilter !== false;
    },
    // 与 H5 一致：仅配置明确开启时才允许切换视图
    allowViewSwitch() {
      return !!(this.mallListSettings && this.mallListSettings.allowViewSwitch);
    }
  },
  watch: {
    searchData: {
      handler() {
        if (this.isEmbeddedInDetail) return;
        // 防抖 initData 落地前先清掉 VIN 标记，避免 keep-alive 窗口内仍按 v=5 打 search
        this.syncSearchVersionFlagsFromEntry();
        this.$nextTick(() => {
          this.initData();
        });
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    calculateCardsPerRow() {
      const container = this.$el.querySelector(".card-product");
      if (!container) return;

      // 获取容器宽度
      this.containerWidth = container.clientWidth;

      // 卡片最小宽度 + 间隙
      const cardMinWidth = 230; // 对应 minmax(230px, 280fr)
      const gap = 2; // gap: 2px

      // 计算一行能容纳的卡片数量
      const availableWidth = this.containerWidth + gap; // 加上一个间隙
      this.cardsPerRow = Math.floor(availableWidth / (cardMinWidth + gap));

      console.log(`容器宽度: ${this.containerWidth}px, 一行可容纳: ${this.cardsPerRow}个卡片`);
      this.params.pageSize = this.cardsPerRow * 3 || 10;
      this.pageSizeList = [this.cardsPerRow * 3, this.cardsPerRow * 5, this.cardsPerRow * 7, this.cardsPerRow * 9];
    },
    changeShowType(n) {
      localStorage.setItem("pageIndex", n);
      this.pageIndex = n;
    },
    // 排序项点击：switch 借助 SortIcon；none 单选/取消
    sortItemClick(item) {
      if (item.mode === "switch") {
        this.currentCode = item.fields;
        const icons = this.$refs.sortIcons || [];
        const list = Array.isArray(icons) ? icons : [icons];
        const icon = list.find(c => c && c.codeName === item.fields);
        if (icon) icon.sortFun();
        return;
      }
      if (this.params.sort === item.fields) {
        this.params.sort = "";
        this.currentCode = "";
      } else {
        this.params.sort = item.fields;
        this.currentCode = item.fields;
      }
      this.getProducts();
    },
    isSortItemActive(item) {
      if (item.mode === "switch") {
        return this.currentCode === item.fields;
      }
      return this.params.sort === item.fields;
    },
    /**
     * 按本次入口立刻对齐 v 标记（不等 debounce）：
     * - 非 VIN 入口清掉 isVinMainCatalog
     * - 顶部搜索栏关键字（type=1）：动态目录，v=1，结束 v=3 并清主/从目录
     */
    syncSearchVersionFlagsFromEntry() {
      const type = Number(this.searchData && this.searchData.type);
      if (type !== 2) {
        this.isVinMainCatalog = false;
        this.vinQueryToken += 1;
        this.chooseVinVisibel = false;
      }
      if (type === 1) {
        this.isHomePageGoodsCategory = false;
        this.params.mainCatalog = undefined;
        this.params.subCatalog = undefined;
      }
      this.searchQueryToken += 1;
    },
    initData: debounce(function() {
      const incomingHomeCatalog = !!this.searchData.fromHomeCatalog;

      this.syncSearchVersionFlagsFromEntry();

      this.resetParams();
      // 入口查询的 areaId 一律以本次 searchData 快照为准：
      // 顶部搜索提交 areaId:0，保证搜索永不带区域条件；
      // 商品目录/查看更多等入口自带 areaId，不受影响
      this.params.areaId = Number(this.searchData.areaId) || 0;
      // 推荐商品「查看更多」：入口带 moduleId，列表查询继续按该模块过滤
      this.params.moduleId = Number(this.searchData.moduleId) || 0;
      // 新一次入口查询：等 search 首包带回 listSettings 后再放开目录联动
      this.pageInited = false;
      this.skipNextCatalogChange = false;
      this.lastFirstPageQueryKey = "";
      this.isVinMainCatalog = false;
      this.vinListSettings = null;
      // v=3 仅首页点商品目录首进（fromHomeCatalog）；顶部关键字一律 v=1 动态目录
      this.isHomePageGoodsCategory = incomingHomeCatalog;
      if (this.searchData.brand) {
        this.params.brand = this.searchData.brand;
      }
      if (this.searchData.productionPlace) {
        this.params.productionPlace = this.searchData.productionPlace;
      }
      if (this.searchData.category) {
        this.params.category = this.searchData.category;
        this.setParamsOthersKey();
      }
      if (this.searchData.type === 2) {
        this.productListData = [];
        // VIN 查询：keyword 即 vin 码（VIN 历史已在搜索组件经 history/content 换取真实 vinCode）
        this.getInfoByVin(this.searchData.keyword);
        return;
      }
      if (this.searchData.type === 1) {
        const historyId = Number(this.searchData.historyId || 0);
        // 历史查件：只带 historyId/historyType，搜索框文案不进 keyword
        if (historyId > 0 || this.searchData.fromHistory) {
          this.params.historyId = historyId;
          this.params.historyType = this.searchData.historyType || "goodsKeyword";
          this.params.keyword = "";
        } else {
          this.params.keyword = this.searchData.keyword || "";
          this.params.historyId = 0;
          this.params.historyType = "";
        }
        this.params.vin = "";
        this.params.vmid = "";
        this.clearStockBuyOnKeywordSearch();
        this.setParamsOthersKey();
        this.getProducts({ updateSettings: "full", resetCatalog: true });
        return;
      }
      if (this.searchData.type === -1) {
        const params = {
          ...this.params,
          ...this.searchData,
          historyId: 0,
          historyType: "",
          fromHistory: undefined
        };
        this.params = params;
        this.setParamsOthersKey();
        this.getProducts({ updateSettings: "full", resetCatalog: true });
        return;
      }
      if (this.searchData.type === -2) {
        this.setParamsOthersKey();
        this.getProducts({ updateSettings: "full", resetCatalog: true });
        return;
      }
    }, 200),
    /** 已设主目录：关键字搜索时清空有货/常购，不沿用上次勾选 */
    clearStockBuyOnKeywordSearch() {
      if (!this.companyHasMainCatalog) return;
      this.params.hasStock = false;
      this.params.isNormalBuy = false;
    },
    //记住有货和常购选项
    remenberParams() {
      if (!this.companyHasMainCatalog) {
        localStorage.setItem("hasStock", JSON.stringify(this.params.hasStock));
        localStorage.setItem("isNormalBuy", JSON.stringify(this.params.isNormalBuy));
      }
      this.getProducts();
    },
    resetParamsAndSearch() {
      this.resetParams(true);
      this.getProducts();
    },
    resetParams(flag) {
      const params = {
        isNormalBuy: false,
        noCategory: false,
        hasStock: true,
        isPromotion: 0,
        page: 1,
        pageSize: 10,
        sort: "",
        productionPlace: "",
        brand: "",
        category: "",
        vin: "",
        vmid: "",
        mainCatalog: undefined,
        subCatalog: undefined,
        custom: "",
        class: "",
        classBrand: "",
        customId: 0,
        categoryId: 0,
        historyId: 0,
        historyType: "",
        areaId: this.params.areaId || 0,
        moduleId: this.params.moduleId || 0
      };
      if (!flag) {
        params.keyword = "";
        params.vin = "";
        params.vmid = "";
      } else {
        params.keyword = this.params.keyword;
        params.vin = this.params.vin;
        params.vmid = this.params.vmid;
        params.historyId = this.params.historyId || 0;
        params.historyType = this.params.historyType || "";
      }
      this.params = params;
      if (!this.companyHasMainCatalog) {
        this.params.hasStock = localStorage.getItem("hasStock") === "true" ? true : false;
        this.params.isNormalBuy = localStorage.getItem("isNormalBuy") === "true" ? true : false;
      }
      this.currentCode = "";
      this.activeFilterKey = "";
      this.calculateCardsPerRow();
    },
    gitList(data) {
      this.resetParams();
      this.componentParams = data;
      this.getProducts({ updateSettings: "full" });
    },
    chooseVin(item) {
      this.vinDetails = item;
      this.params.vin = this.vinDetails.vinCode;
      this.params.vmid = this.vinDetails.id;
      this.chooseVinVisibel = false;
      this.afterVinVehicleReady();
    },
    async getInfoByVin(vin) {
      const token = ++this.vinQueryToken;
      try {
        this.isVinMainCatalog = false;
        this.vinListSettings = null;
        this.vinDetails = {};
        this.vinList = [];
        const res = await getDataByVin(vin);
        if (token !== this.vinQueryToken) return;
        // search-vin 返回 { vehicles, listSettings }；listSettings 为指针字段，可能为 null
        const vehicles = (res && res.vehicles) || [];
        this.vinList = vehicles;
        this.vinListSettings = (res && res.listSettings) || null;
        if (vehicles.length === 1) {
          this.vinDetails = vehicles[0];
          this.params.vin = this.vinDetails.vinCode;
          this.params.vmid = this.vinDetails.id;
          this.afterVinVehicleReady();
          return;
        }
        if (vehicles.length > 1) {
          this.chooseVinVisibel = true;
          return;
        }
        this.$message.error("未查询到车型");
        this.pageInited = true;
      } catch (error) {
        if (token !== this.vinQueryToken) return;
        if (error && error.message) {
          this.$message.error(error.message);
        }
        this.pageInited = true;
      }
    },
    /**
     * VIN 车型已确定：
     * - search-vin 返回 catalogs 有值 → 点选第一个主目录查询，不带默认关键字
     * - catalogs 为空 → 回退店铺 VIN 默认关键字自动搜
     */
    afterVinVehicleReady() {
      if (Number(this.searchData.type) !== 2) return;
      if (hasVinMainCatalog(this.vinListSettings)) {
        this.isVinMainCatalog = true;
        this.applyVinCatalogSettings(this.vinListSettings);
        this.$nextTick(() => {
          if (this.$refs.catalogSidebar) {
            this.$refs.catalogSidebar.selectFirstMainCatalog();
          }
          this.getProducts({ updateSettings: "full", resetCatalog: true });
        });
        return;
      }
      this.isVinMainCatalog = false;
      this.searchByVinDefaultKey();
    },
    /** VIN 主目录模式：主目录固定用 search-vin 快照，首包直接带第一个主目录 */
    applyVinCatalogSettings(settings) {
      this.keywordListSettings = cloneMallListSettings(settings);
      this.mallListSettings = cloneMallListSettings(settings);
      this.subResolveHasMainCatalog = false;
      const catalogPatch = buildFirstMainCatalogQueryFromSettings(settings);
      this.params.keyword = "";
      this.params.mainCatalog = catalogPatch ? catalogPatch.mainCatalog : undefined;
      this.params.subCatalog = catalogPatch ? catalogPatch.subCatalog : undefined;
      if (this.$refs.vinKeywordSearch) {
        this.$refs.vinKeywordSearch.keyword = "";
      }
    },
    /** catalogs 为空时：用店铺 VIN 默认关键字查列表 */
    searchByVinDefaultKey() {
      const company = this.$store.getters["companyInfo/companyInfo"] || {};
      const vinDefaultKey =
        (company.setting && company.setting.wxSetting && company.setting.wxSetting.vinDefaultKey) || [];
      const kw = Array.isArray(vinDefaultKey) ? vinDefaultKey.filter(Boolean).join(",") : "";
      this.params.keyword = kw && kw.length >= 2 ? kw : "";
      this.params.mainCatalog = undefined;
      this.params.subCatalog = undefined;
      if (this.params.keyword && this.$refs.vinKeywordSearch) {
        this.$refs.vinKeywordSearch.keyword = this.params.keyword;
      }
      if (!this.params.keyword) {
        this.pageInited = true;
        return;
      }
      this.getProducts({ updateSettings: "full", resetCatalog: true });
    },
    openVinDetailsPopup(item) {
      const vinDetails = item || this.vinDetails;
      this.vinDetailsIframeUrl = `/vehicleConfigDetails?vin=${vinDetails.vinCode}&vmid=${vinDetails.id}`;
      this.vinDetailsIframeVisible = true;
    },
    setParamsOthersKey() {
      if (this.params.category === "未分类") {
        this.params.noCategory = true;
      } else {
        this.params.noCategory = false;
      }
    },
    getFilterField(item) {
      return (item && (item.queryField || item.key)) || "";
    },
    getFilterSelectedValue(item) {
      // 自定义目录：用 customId 判断是否选中
      if (item.catalogType === "custom") {
        return this.params.customId ? String(this.params.customId) : "";
      }
      // 分类：用 categoryId 判断是否选中
      const field = this.getFilterField(item);
      if (field === "category") {
        return this.params.categoryId ? String(this.params.categoryId) : "";
      }
      // 品类（可多级）：已选到第二级时用 classBrand 定位树中高亮节点，否则用第一级 class
      if (item.catalogType === "class" || field === "class") {
        return this.params.classBrand || this.params.class || "";
      }
      const val = field ? this.params[field] : "";
      return val !== undefined && val !== null && String(val) !== "" ? String(val) : "";
    },
    // 在筛选项 values 树中按 value/name 递归查找节点（品类多级时目标节点可能在深层 children 里）
    findFilterOptionNode(values, search) {
      if (!Array.isArray(values)) return null;
      for (const opt of values) {
        if (!opt) continue;
        if (String(opt.value) === search || opt.name === search) return opt;
        if (opt.children && opt.children.length) {
          const found = this.findFilterOptionNode(opt.children, search);
          if (found) return found;
        }
      }
      return null;
    },
    getFilterSelectedLabel(item) {
      // 自定义目录：显示 custom 字段（名称）
      if (item.catalogType === "custom") {
        return this.params.custom || "";
      }
      // 分类：显示 category 字段（名称）
      const field = this.getFilterField(item);
      if (field === "category") {
        return this.params.category || "";
      }
      // 品类（可多级）：selected 可能是深层节点的 value，需要递归查找
      if (item.catalogType === "class" || field === "class") {
        const selected = this.getFilterSelectedValue(item);
        if (!selected) return "";
        const hit = this.findFilterOptionNode(item.values, selected);
        return (hit && hit.name) || selected;
      }
      // 其他：直接返回存储的值
      const selected = this.getFilterSelectedValue(item);
      if (!selected) return "";
      const hit = (item.values || []).find(opt => String(opt.value) === selected || opt.name === selected);
      return (hit && hit.name) || selected;
    },
    // 判断筛选值是否含多级（children）
    filterHasChildren(values) {
      if (!Array.isArray(values)) return false;
      return values.some(v => (v && v.children && v.children.length > 0) || this.filterHasChildren(v && v.children));
    },
    // 递归剔除「全部」等空 value 节点
    stripEmptyValues(values) {
      if (!Array.isArray(values)) return [];
      return values
        .filter(v => v && String(v.value) !== "")
        .map(v => ({
          ...v,
          children: v.children ? this.stripEmptyValues(v.children) : undefined
        }));
    },
    // 打开筛选弹窗（单选）：多级走 CategorieSelect，平级走 BrandPanel
    openSelectFilterPopup(item) {
      this.activeFilterKey = item.key;
      this.activeFilterItem = item;
      const selectedLabel = this.getFilterSelectedLabel(item);

      // 多级（自定义目录/分类）：使用 master 分支的分栏逐级展开弹窗
      if (this.filterHasChildren(item.values)) {
        const panel = this.$refs.selectTreeFilterPanel;
        if (!panel) return;
        if (panel.show) {
          panel.cancel();
          return;
        }
        // 与购物车页一致：包一层「全部分类」合成根，首列展示根项，一级分类列才展示真实节点
        const tree = this.stripEmptyValues(item.values || []);
        panel.open(true, [{ id: "all", name: "全部分类", children: tree }], selectedLabel || null);
        return;
      }

      // 平级单选：BrandPanel
      const panel = this.$refs.selectFilterPanel;
      if (!panel) return;

      // 再次点击同一项：关闭
      if (panel.show) {
        panel.cancel();
        return;
      }
      panel.open(item.values || [], selectedLabel || null);
    },
    closeSelectFilterPopup() {
      this.activeFilterKey = "";
      this.activeFilterItem = null;
    },
    selectActiveFilterConfirm(selectedItem, path) {
      if (this.activeFilterItem) {
        this.selectFilterConfirm(this.activeFilterItem, selectedItem, path);
      }
    },
    /**
     * 筛选确认（单选）
     * - 自定义目录：传 customId（节点 id）
     * - 分类：传 categoryId（节点 id）+ category (name)
     * - 品类（可多级）：按选中路径逐级传值，第一级 class，第二级 classBrand（无第二级则清空）；
     *   path 为多级面板（CategorieSelect）传回的第一级到叶子的完整路径，平级面板（BrandPanel）无 path
     * - 其他：传 queryField = value
     */
    selectFilterConfirm(item, selectedItem, path) {
      const field = this.getFilterField(item);
      const isClass = item.catalogType === "class" || field === "class";

      // 重置/取消选中：清空对应筛选条件；选中「全部分类」合成根（id: "all"）等同不筛选
      if (!selectedItem || selectedItem.id === "all") {
        if (item.catalogType === "custom") {
          this.$set(this.params, "customId", 0);
          this.$set(this.params, "custom", "");
        } else if (field === "category") {
          this.$set(this.params, "categoryId", 0);
          this.$set(this.params, "category", "");
          this.setParamsOthersKey();
        } else if (isClass) {
          this.$set(this.params, "class", "");
          this.$set(this.params, "classBrand", "");
        } else if (field) {
          this.$set(this.params, field, "");
        }
        this.params.page = 1;
        this.getProducts();
        return;
      }

      if (item.catalogType === "custom") {
        // 自定义目录：传 customId（后端节点真实 id，而非 value）
        this.$set(this.params, "customId", Number(selectedItem.id) || 0);
        this.$set(this.params, "custom", selectedItem.name);
      } else if (field === "category") {
        // 分类：传 categoryId（节点 id）+ category
        this.$set(this.params, "categoryId", Number(selectedItem.id) || 0);
        this.$set(this.params, "category", selectedItem.name);
        this.setParamsOthersKey();
      } else if (isClass) {
        // 品类：无 path（平级选择）时用选中项自身当第一级
        let nodes = path && path.length ? path : [selectedItem];
        // 多级面板包了「全部分类」合成根（id: "all"），提交前剔除，保证 class/classBrand 层级不错位
        if (nodes.length > 1 && nodes[0] && nodes[0].id === "all") {
          nodes = nodes.slice(1);
        }
        this.$set(this.params, "class", (nodes[0] && nodes[0].value) || "");
        this.$set(this.params, "classBrand", (nodes[1] && nodes[1].value) || "");
      } else if (field) {
        // 其他筛选项
        this.$set(this.params, field, selectedItem.value);
      }
      this.params.page = 1;
      this.getProducts();
    },
    /**
     * 主/从目录切换：更新 mainCatalog / subCatalog 并刷新列表
     * - 配件详情嵌套时不走目录
     * - 首包 listSettings 落定前忽略目录事件，避免默认选中二次 search
     * - 关键字搜索刷新配置触发的目录重置：列表已拉过，跳过一次
     * - 切主：合并 catalogDetails + 当前主目录 + filterSettings，再拼从目录
     * - 切从：只覆盖 filterSettings，不动 catalogs / catalogDetails
     */
    onCatalogChange({ main, sub, changeType }) {
      if (this.isEmbeddedInDetail) return;
      if (!this.pageInited) return;
      if (this.skipNextCatalogChange) {
        this.skipNextCatalogChange = false;
        return;
      }

      const catalogPatch = buildCatalogQueryFromSelection(main, sub);
      this.params = {
        ...this.params,
        mainCatalog: catalogPatch ? catalogPatch.mainCatalog : undefined,
        subCatalog: catalogPatch ? catalogPatch.subCatalog : undefined,
        productionPlace: "",
        brand: "",
        category: "",
        custom: "",
        class: "",
        classBrand: "",
        customId: 0,
        categoryId: 0,
        // 首页目录带 areaId 进入后，切换目录查询不再限定商品区
        areaId: 0
      };
      this.params.page = 1;
      this.activeFilterKey = "";
      this.activeFilterItem = null;
      if (changeType === "sub") {
        this.getProducts({ updateSettings: "filterSettings" });
        return;
      }
      this.getProducts({ updateSettings: "catalogDetails" });
    },
    /** 用 listSettings 默认主/从目录同步 query，不发起请求（后端首包已是该结果） */
    syncDefaultCatalogQuery(settings) {
      if (this.isEmbeddedInDetail) return;
      const catalogPatch = buildDefaultCatalogQueryFromSettings(settings);
      this.params = {
        ...this.params,
        mainCatalog: catalogPatch ? catalogPatch.mainCatalog : undefined,
        subCatalog: catalogPatch ? catalogPatch.subCatalog : undefined
      };
    },
    changeSort(sort, code) {
      this.currentCode = code;
      if (sort) {
        this.params.sort = `${code}-${sort}`;
      } else {
        this.params.sort = "";
      }
      this.getProducts();
    },
    handleSizeChange(v) {
      this.$set(this.params, "pageSize", v);
      this.getProducts();
    },
    handleCurrentChange(v) {
      this.$set(this.params, "page", v);
      this.getProducts();
    },
    lastPage() {
      this.params.page--;
      if (this.params.page < 1) {
        this.params.page = 1;
      }
      this.getProducts();
    },
    nextPage() {
      this.params.page++;
      if (this.params.page > Math.ceil(this.total / this.params.pageSize)) {
        this.params.page = Math.ceil(this.total / this.params.pageSize);
      }
      this.getProducts();
    },
    /**
     * 商品列表查询（POST /mall/goods/search）
     * @param {boolean|{ updateSettings?: true|"full"|"catalogDetails"|"filterSettings", resetCatalog?: boolean }} flagOrOptions
     * - true：刷新列表但不滚顶（如加购后 refresh）
     * - { updateSettings: "full"|true }：整包回写 listSettings（仅首开/关键字，含目录与筛选项）
     * - { updateSettings: "catalogDetails" }：切主合 catalogDetails / 当前主目录 / filterSettings
     * - { updateSettings: "filterSettings" }：切从只覆盖筛选项
     * - { resetCatalog: true }：同步默认目录 query，并强制目录 UI 归零（仅 full）
     * 配件详情嵌套：不传/不回写主从目录，只用 listSettings 驱动筛选排序
     */
    async getProducts(flagOrOptions) {
      const isOptions = flagOrOptions && typeof flagOrOptions === "object";
      const rawUpdate = isOptions ? flagOrOptions.updateSettings : false;
      const updateMode =
        rawUpdate === true || rawUpdate === "full"
          ? "full"
          : rawUpdate === "catalogDetails" || rawUpdate === "filterSettings"
          ? rawUpdate
          : "";
      const resetCatalog = isOptions ? !!flagOrOptions.resetCatalog : false;
      const skipScrollTop = isOptions ? false : !!flagOrOptions;

      this.loading = true;
      const token = ++this.searchQueryToken;
      try {
        let params = {};
        if (this.isEmbeddedInDetail) {
          params = {
            ...this.params,
            ...this.componentParams
          };
          delete params.mainCatalog;
          delete params.subCatalog;
        } else {
          params = window.tool.deepClone(this.params);
        }
        if (!params.moduleId) {
          delete params.moduleId;
        }
        // 按本次入口写 v，不沿用 this.params 里上次的值
        // v=5 仅 VIN 会话；v=3 仅首页目录会话；首页/顶部关键字默认 v=1
        delete params.v;
        if (Number(this.searchData.type) === 2 && this.isVinMainCatalog) {
          params.v = 5;
        } else if (this.isHomePageGoodsCategory) {
          params.v = 3;
        } else {
          params.v = 1;
        }
        // 历史查件：只带 historyId/historyType，不带 keyword（与 H5 一致）
        params.historyId = Number(params.historyId || 0);
        if (params.historyId > 0) {
          params.keyword = "";
        } else {
          params.historyId = 0;
          params.historyType = "";
        }
        // 入口/关键字首包：相同条件不重复打 search（默认选中二次触发时参数会变，主要靠 silent reset）
        if (resetCatalog && Number(params.page) === 1) {
          const queryKey = JSON.stringify(params);
          if (queryKey === this.lastFirstPageQueryKey) {
            if (token !== this.searchQueryToken) return;
            this.loading = false;
            this.$nextTick(() => {
              this.pageInited = true;
            });
            return;
          }
          this.lastFirstPageQueryKey = queryKey;
        }
        const res = await getGoodsList(params);
        if (token !== this.searchQueryToken) return;
        if (!res.rows || res.rows.length === 0) {
          this.productListData = [];
          this.total = 0;
        } else {
          this.productListData = res.rows.map(item => {
            if (Number(item.minBuyQty) && Number(item.uQty)) {
              item.minQty = window.tool.getOrderQuantity(Number(item.minBuyQty), Number(item.uQty));
            } else {
              item.minQty = 1;
            }
            item.orderQuantity = Number(item.cartQty) || item.minQty || 1;
            return item;
          });
          this.total = res.totalSize;
        }
        if (this.isEmbeddedInDetail) {
          // 详情嵌套：只落筛选/排序配置，不处理主从目录
          if ((updateMode || !this.mallListSettings) && res.listSettings) {
            this.mallListSettings = res.listSettings;
          }
        } else if (updateMode && res.listSettings) {
          const hadSettings = !!this.mallListSettings;
          if (updateMode === "filterSettings") {
            this.mallListSettings = applyListSettingsFromSearch(
              this.mallListSettings,
              res.listSettings,
              updateMode,
              this.keywordListSettings
            );
          } else if (this.isVinMainCatalog) {
            // VIN 查件整份/切主：主目录仍固定使用 search-vin 快照；从目录、筛选项和排序跟随本次 search
            this.mallListSettings = mergeVinListSettingsFromSearch(
              this.mallListSettings || this.keywordListSettings,
              res.listSettings,
              this.params.mainCatalog && this.params.mainCatalog.type
                ? { type: this.params.mainCatalog.type, name: this.params.mainCatalog.name || "" }
                : null
            );
            this.subResolveHasMainCatalog = !!(this.params.mainCatalog && this.params.mainCatalog.type);
          } else if (updateMode === "full") {
            this.keywordListSettings = cloneMallListSettings(res.listSettings);
            this.mallListSettings = res.listSettings;
            this.subResolveHasMainCatalog = false;
          } else {
            const mainRef = this.params.mainCatalog;
            this.mallListSettings = applyListSettingsFromSearch(
              this.mallListSettings,
              res.listSettings,
              updateMode,
              this.keywordListSettings,
              mainRef && mainRef.type ? { type: mainRef.type, name: mainRef.name || "" } : null
            );
            this.subResolveHasMainCatalog = !!(mainRef && mainRef.type);
          }
          if (resetCatalog && updateMode === "full") {
            if (this.isVinMainCatalog) {
              // VIN 主目录冻结：不按 search 默认目录重写 query，只把从目录归零
              if (hadSettings && this.pageInited) {
                this.skipNextCatalogChange = true;
                this.$nextTick(() => {
                  if (this.$refs.catalogSidebar) {
                    this.$refs.catalogSidebar.resetSubToDefault();
                  } else {
                    this.skipNextCatalogChange = false;
                  }
                });
              }
            } else {
              // 后端首包已按默认主目录返回：只同步 query / 高亮，不 emit、不二次 search
              this.syncDefaultCatalogQuery(res.listSettings);
              this.skipNextCatalogChange = true;
              this.$nextTick(() => {
                if (this.$refs.catalogSidebar) {
                  this.$refs.catalogSidebar.resetToDefault(false);
                }
                this.skipNextCatalogChange = false;
              });
            }
          }
        } else if (updateMode === "full" && !res.listSettings && !this.isVinMainCatalog) {
          this.mallListSettings = null;
          this.keywordListSettings = null;
          this.subResolveHasMainCatalog = false;
        }
      } catch (error) {
        if (token !== this.searchQueryToken) return;
        this.$message.error(error.message || "获取商品失败");
        this.productListData = [];
        this.total = 0;
        if (resetCatalog) {
          this.lastFirstPageQueryKey = "";
          this.pageInited = true;
        }
      }
      if (token !== this.searchQueryToken) return;
      this.loading = false;
      if (resetCatalog) {
        this.$nextTick(() => {
          this.pageInited = true;
        });
      } else if (updateMode && !this.pageInited) {
        this.$nextTick(() => {
          this.pageInited = true;
        });
      }
      if (!this.isEmbeddedInDetail && !skipScrollTop) {
        this.$bus.$emit("scrollTop");
      }
    },
    searchKeywordChange(v) {
      const isHistory = v && typeof v === "object";
      const historyId = isHistory ? Number(v.historyId || 0) : 0;
      const historyType = isHistory ? v.historyType || "vinKeyword" : "";
      this.params.keyword = historyId > 0 ? "" : isHistory ? v.keyword || "" : v;
      this.params.historyId = historyId;
      this.params.historyType = historyId > 0 ? historyType : "";
      this.params.page = 1;
      this.params.moduleId = 0;
      this.params.subCatalog = undefined;
      this.params.productionPlace = "";
      this.params.brand = "";
      this.params.category = "";
      this.params.custom = "";
      this.params.class = "";
      this.params.classBrand = "";
      this.params.customId = 0;
      this.params.categoryId = 0;
      // VIN 主目录冻结：保留 mainCatalog，只清从目录；普通查询清空主从目录
      if (!this.isVinMainCatalog) {
        this.params.mainCatalog = undefined;
      }
      this.clearStockBuyOnKeywordSearch();
      this.getProducts({ updateSettings: "full", resetCatalog: true });
    }
  },
  mounted() {
    // this.getProducts();
    this.calculateCardsPerRow();
  },
  created() {
    if (localStorage.getItem("pageIndex")) {
      this.pageIndex = Number(localStorage.getItem("pageIndex"));
    }
  },
  beforeDestroy() {}
};
</script>

<style>
.none-border .el-input .el-input__inner {
  border: none;
}
.vinDetailsIframe {
  width: 100%;
  height: calc(100vh - 200px);
  border-radius: 8px;
}

.custom-dialog {
  border-radius: 12px;
  overflow: hidden;
}

.custom-dialog .el-dialog__header {
  /* background: linear-gradient(135deg, var(--color-primary) 0%, #764ba2 100%); */
  background: var(--color-primary);
  padding: 16px 20px;
}

.custom-dialog .el-dialog__title {
  color: white;
  font-weight: 600;
}

.custom-dialog .el-dialog__headerbtn {
  top: 16px;
}

.custom-dialog .el-dialog__headerbtn .el-dialog__close {
  color: white;
}
.custom-dialog .el-dialog__headerbtn .el-dialog__close:hover {
  color: #fff;
}
</style>

<style lang="scss" scoped>
.top-pagination {
  display: flex;
  align-items: center;
  column-gap: 8px;
  flex-shrink: 0;
  span {
    font-size: 14px;
    color: var(--color-primary);
  }
}
.parent {
  // background: #f5f7fa;
  min-height: 100vh;
  // padding: 16px;
}

.box {
  margin: 0 auto;
  min-height: calc(100vh - 32px);
  display: flex;
  flex-direction: column;

  .vehicle-logo {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    object-fit: cover;
    border: 2px solid #e4e7ed;
  }
}

// 搜索栏样式
.search-bar {
  background: white;
  border-radius: 12px;
  padding: 20px 24px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  display: flex;
  align-items: center;
  justify-content: space-between;

  .bar {
    display: flex;
    align-items: center;
    gap: 12px;
    width: calc(100% - 410px);

    .title {
      max-width: calc(100% - 50px);
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      .vehicle-title {
        font-size: 16px;
        font-weight: 600;
        color: #303133;
      }
    }

    .info {
      width: 50px;
      flex-shrink: 0;
      color: var(--color-primary);
      font-size: 14px;
      cursor: pointer;
      font-weight: 500;
      transition: color 0.3s;

      &:hover {
        color: #67c23a;
      }
    }
  }

  .search-box {
    width: 400px;
  }
}

// 筛选区域样式
.filter-section {
  flex-shrink: 0;
  background: white;
  border-radius: 2px;
  padding: 8px 12px;
  margin-bottom: 4px;
  // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  width: 100%;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 16px;

  .sort-box {
    align-items: center;
    flex-wrap: wrap;
    flex-direction: row;
    gap: 8px;
    min-width: 0;

    .el-divider--vertical {
      height: 16px;
      margin: 0 4px;
    }

    .sort-item {
      padding: 8px 12px;
      border-radius: 6px;
      cursor: pointer;
      transition: all 0.3s ease;
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 14px;
      color: #606266;
      border: 1px solid transparent;

      &:hover {
        background: #f5f7fa;
        color: var(--color-primary);
      }

      &.active {
        background: color-mix(in srgb, var(--color-light80) 30%, transparent) !important;
        color: var(--color-primary);
        // border-color: var(--color-primary);
      }

      &.filter-active {
        background: color-mix(in srgb, var(--color-light80) 30%, transparent) !important;
        border-color: var(--color-primary);
      }

      .chooseTxt {
        max-width: 120px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;

        span {
          color: var(--color-primary);
          font-weight: 500;
        }
      }

      .trigger-icon {
        transition: transform 0.3s;
        font-size: 12px;
        color: #c0c4cc;
      }

      &.filter-active .trigger-icon {
        transform: rotate(180deg);
        color: var(--color-primary);
      }

      &.checkbox-item {
        border: none;
        background: transparent;

        &:hover {
          background: #f5f7fa;
        }

        &.active {
          background: #ecf5ff;

          ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
            background-color: var(--color-primary);
            border-color: var(--color-primary);
          }

          ::v-deep .el-checkbox__label {
            color: var(--color-primary);
            font-weight: 500;
          }
        }
      }
    }
  }

  .view-toggle {
    flex-direction: row;
    align-items: center;
    flex-shrink: 0;
    gap: 8px;

    i {
      font-size: 20px;
      color: #c0c4cc;
      cursor: pointer;
      padding: 8px;
      border-radius: 6px;
      transition: all 0.3s;

      &:hover {
        background: #f5f7fa;
        color: var(--color-primary);
      }

      &.active {
        background: color-mix(in srgb, var(--color-light80) 30%, transparent) !important;
        color: var(--color-primary);
      }
    }
  }
}

// 产品内容区域
.product-content {
  flex: 1;
  background: white;
  // border-radius: 12px;
  overflow: hidden;
  // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

  .card-product {
    padding: 16px;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(230px, 280fr));
    gap: 2px;
  }
}

// 空状态样式
.empty-state {
  padding: 80px 20px;
  text-align: center;
  color: #909399;

  i {
    font-size: 64px;
    margin-bottom: 16px;
    color: #c0c4cc;
  }

  p {
    font-size: 16px;
    margin-bottom: 24px;
  }
}

// 分页样式
.pagination-container {
  background: white;
  border-radius: 2px;
  padding: 12px 20px;
  margin-top: 16px;
  // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  display: flex;
  justify-content: center;

  ::v-deep .el-pagination {
    .btn-prev,
    .btn-next,
    .number,
    .el-pager li {
      border-radius: 6px;
      margin: 0 2px;
    }

    .el-pager li.active {
      background: var(--color-primary);
      color: white;
    }
  }
}

// VIN列表样式
.vinList {
  display: flex;
  flex-direction: column;
  gap: 8px;

  .item {
    padding: 16px;
    border-radius: 8px;
    border: 1px solid #e4e7ed;
    display: flex;
    align-items: center;
    gap: 12px;
    transition: all 0.3s;
    cursor: pointer;

    &:hover {
      background: #f5f7fa;
      border-color: var(--color-primary);
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(64, 158, 255, 0.1);
    }

    &.active {
      background: #ecf5ff;
      border-color: var(--color-primary);

      .title span {
        color: var(--color-primary);
      }
    }

    .title {
      flex: 1;
      span {
        font-size: 14px;
        color: #303133;
        font-weight: 500;
      }
    }

    .info {
      color: var(--color-primary);
      font-size: 13px;
      cursor: pointer;
      font-weight: 500;
      transition: color 0.3s;

      &:hover {
        color: #67c23a;
      }
    }
  }
}

// 响应式设计
@media (max-width: 1200px) {
  .box {
    width: 100% !important;
  }

  // .search-bar {
  //   flex-direction: column;
  //   gap: 16px;

  //   .bar {
  //     width: 100%;
  //   }

  //   .search-box {
  //     width: 100%;
  //   }
  // }

  .filter-section {
    .sort-box {
      gap: 4px;

      .sort-item {
        padding: 6px 8px;
        font-size: 13px;
      }
    }
  }

  .product-content .card-product {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  }
}

@media (max-width: 768px) {
  .parent {
    padding: 8px;
  }

  .filter-section {
    flex-direction: column;
    align-items: stretch;

    .sort-box {
      justify-content: center;
    }

    .view-toggle {
      justify-content: center;
    }
  }

  .product-content .card-product {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .pagination-container {
    padding: 16px 8px;

    ::v-deep .el-pagination {
      .btn-prev,
      .btn-next,
      .number,
      .el-pager li {
        margin: 0 1px;
        min-width: 32px;
        height: 32px;
        line-height: 32px;
      }
    }
  }
}

// 动画效果
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}
</style>
